<h1 mat-dialog-title class="text-center"> {{'Notices' | translatei18n}}</h1>

<mat-dialog-content>

    <ng-container *ngFor="let item of data" class="m-5">
        <div [ngClass]="item.read ? 'm-5' : 'font-black m-5'">
            {{item.dtStart | date:'dd MMM yyyy'}}
            <span [ngClass]="item.read ? 'text-red-500 invisible' : 'text-red-500'">
                {{'New!' | translatei18n}}
            </span>
            {{item.notificationText}}
            <span *ngIf="item.attachedFile">
                <a (click)="goTo()">{{'Click here' | translatei18n}}</a> {{'Follow Instructions' | translatei18n}}
            </span>
        </div>
        <hr>
    </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="center">
    <button mat-button (click)="cancel()">{{cancelButton | translatei18n}}</button>
</mat-dialog-actions>